var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.images),function(img,key){return _c('div',{key:key},[_c('img',{attrs:{"src":_vm.imageDir + key.substr(1)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }